var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportStolen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6464 12.663L11.7002 1.60707C10.5483 -0.535688 7.4526 -0.535688 6.3007 1.60707L0.354481 12.663C-0.702924 14.6269 0.732448 17 2.97775 17H15.0232C17.2685 17 18.7016 14.6269 17.6464 12.663ZM8.32552 6.26386C8.32552 5.89257 8.62699 5.59286 9.00046 5.59286C9.37393 5.59286 9.6754 5.89257 9.6754 6.26386V9.84258C9.6754 10.2139 9.37393 10.5136 9.00046 10.5136C8.62699 10.5136 8.32552 10.2139 8.32552 9.84258V6.26386ZM9.01846 13.4213C8.52125 13.4213 8.11404 13.0209 8.11404 12.5266C8.11404 12.0323 8.51225 11.6319 9.00946 11.6319H9.01846C9.51566 11.6319 9.91838 12.0323 9.91838 12.5266C9.91838 13.0209 9.51566 13.4213 9.01846 13.4213Z",
    fill: "#474554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportStolen);
export default __webpack_public_path__ + "static/media/report-stolen.dcb2fc84f021b29e797a151040a38ae9.svg";
export { ForwardRef as ReactComponent };